export const logError = (...args) => {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(...args);
  }
};

export const logDebug = (...args) => {
  if (
    typeof console !== "undefined" &&
    typeof console.debug === "function" &&
    import.meta.env.DEV
  ) {
    console.debug(...args);
  }
};
